import {
  BonusActionsWrapper,
  BonusContent,
  BonusItemNew,
  BonusName,
  EventName,
} from '@/flat-pages/bonuses/ui/styles';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { BonusActions } from '@/flat-pages/bonuses/ui/bonus-actions';
import { useScopedI18n } from '@locales/client';
import { getThemeBrand } from '@/shared/hooks/useBrandTheme';
import { isBonusActive } from '@/flat-pages/bonuses/model/utils';

export const BonusItemComponent = ({
  bonus,
  onClickHandler,
  locale,
  updateDate,
  isCarousel,
}) => {
  const t = useScopedI18n('bonus');

  return (
    <BonusItemNew
      $tint={bonus.color}
      $isEnable={isBonusActive(bonus)}
      $isActive={bonus?.state === 'active'}
      $isCarousel={isCarousel}
      key={bonus?.id}
      $bg={resolveMediaPath(bonus?.pic || getThemeBrand().assets.loader.default)}
      onClick={() => onClickHandler(bonus)}
    >
      <BonusContent
        $isActive={bonus?.isActive}
        // onClick={onClickHandler(bonus)}
      >
        <EventName>
          <BodyTextRegularB>
            {bonus?.eventName ? bonus?.eventName : ' '}
          </BodyTextRegularB>
        </EventName>
        <BonusName $isCarousel={isCarousel}>{bonus?.name}</BonusName>

        <BonusActionsWrapper
          $isCarousel={isCarousel}
          $marginTop="auto"
          $display="flex"
          $paddingBottom={isCarousel ? ['4px', '20px'] : 0}
        >
          <BonusActions
            bonus={bonus}
            updateDate={updateDate}
            t={t}
            locale={locale}
          />
        </BonusActionsWrapper>
      </BonusContent>
    </BonusItemNew>
  );
};
